import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignCambioPerspectivaProps {
  sign: Sign;
}
export function SignCambioPerspectiva({
  sign
}: SignCambioPerspectivaProps) {
  return <section className="relative py-24 md:py-32 px-4 md:px-6 bg-transparent flex flex-col items-center justify-center text-center" data-id="element-850">
      <div className="container mx-auto max-w-4xl" data-id="element-851">
        <AnimatedSection data-id="element-852">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight" style={{
          textShadow: `0 0 40px ${sign.colors.primary}50`
        }} data-id="element-853">
            No eres un signo. Eres un Reino.
          </h2>

          <p className="text-lg md:text-xl lg:text-2xl font-serif italic max-w-3xl mx-auto mb-16 leading-relaxed" style={{
          color: sign.colors.accent
        }} data-id="element-854">
            No es solo astrología. Es una experiencia simbólica diseñada para
            explorar patrones emocionales, identidad y comportamiento interno.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-855">
          <div className="flex flex-col items-center justify-center" data-id="element-856">
            <div className="flex items-center justify-center mb-6" data-id="element-857">
              <div className="h-px w-16 md:w-24" style={{
              background: `linear-gradient(90deg, transparent, ${sign.colors.primary}80)`
            }} data-id="element-858" />
              <div className="mx-4 w-2 h-2 rotate-45" style={{
              backgroundColor: sign.colors.primary,
              boxShadow: `0 0 10px ${sign.colors.primary}`
            }} data-id="element-859" />
              <div className="h-px w-16 md:w-24" style={{
              background: `linear-gradient(90deg, ${sign.colors.primary}80, transparent)`
            }} data-id="element-860" />
            </div>

            <p className="text-[11px] md:text-xs tracking-[0.4em] uppercase font-serif font-semibold" style={{
            color: sign.colors.accent,
            textShadow: `0 0 15px ${sign.colors.primary}60`
          }} data-id="element-861">
              Entra al Núcleo del Arquetipo.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}